"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomePricingTable = void 0;
const Pricing_1 = require("../entity/Pricing");
const pricingTableCell_1 = require("./pricingTableCell");
const createSomePricingTable = ({ creativeTypeId = '12345678', cells = [pricingTableCell_1.createSomePricingTableCell(), pricingTableCell_1.createSomePricingTableCell()], } = {}) => new Pricing_1.PricingTable({ creativeTypeId, cells });
exports.createSomePricingTable = createSomePricingTable;
